import React from 'react';

const SalesSectionPlaceholder = ({ title, description, icon = '📋' }) => (
  <div className="p-6">
    <div className="mb-6">
      <h1 className="text-2xl font-semibold text-gray-800 flex items-center gap-2">
        <span aria-hidden>{icon}</span>
        {title}
      </h1>
      {description ? <p className="text-sm text-gray-500 mt-1">{description}</p> : null}
    </div>
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
      <p className="text-gray-500">Esta sección se implementará en la siguiente iteración del módulo de Ventas.</p>
    </div>
  </div>
);

export default SalesSectionPlaceholder;
